import React from 'react'
import { Wrapper } from '@farewill/ui'
import { COLOR } from '@farewill/ui/tokens'

import WrapperWithEdge from 'components/WrapperWithEdge'
import CustomerQuote from 'components/CustomerQuote'

const SliceCustomerQuote = (): React.ReactElement => (
  <WrapperWithEdge direction="down" edgeBackgroundColor={COLOR.WHITE}>
    <Wrapper container>
      <CustomerQuote id="terry-cremation" showTrustpilot />
    </Wrapper>
  </WrapperWithEdge>
)

export default SliceCustomerQuote
